
import RedirectCreate from "../pages/redirect/addRedirect";
import RedirectEdit from "../pages/redirect/EditRedirect";
import RedirectIndex from "../pages/redirect/redirect";

const redirectRoutes = [
  {
    path: "redirects",
    element: <RedirectIndex />,
  },
  {
    path: "redirects/add",
    element: <RedirectCreate />,
  },
  {
    path: "redirects/edit/:id",
    element: <RedirectEdit />,
  },
];

export default redirectRoutes;